import React, { useState, useEffect, useRef } from 'react';
import { getVideoById, likeDislikeShorts, getComments, addComment, deleteComment, deleteShortsVideo } from '../../api/shortsVideo';
import { submitVote, getVoteDetailsById, likeDislike } from '../../api/Vote';
import { getUser } from '../../api/auth';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import PermIdentityRoundedIcon from '@mui/icons-material/PermIdentityRounded';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import humanizeDuration from 'humanize-duration';
import { useSearchParams } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import DashboardRightSection from '../DashboardRightSection/DashboardRightSection';
import Header from '../Header/Header';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import FaceRecognition from '../FaceRecognition/FaceRecognition';
import CloseIcon from '@mui/icons-material/Close';
import Loader from '../Loader';
import { getUserId } from '../../api/index';
import { getToken } from '../../api/index';
import InfoOutlineRoundedIcon from '@mui/icons-material/InfoOutlineRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { getHumanizedTime } from '../getHumanizedTime';
import SubscriptionPrompt from '../Shared/SubscriptionPrompt';
import ProfileCompletionPrompt from '../Shared/ProfileCompletionPrompt';
import useGovtIdVerification from '../../hooks/useGovtIdVerification';
import ShareModal from '../Shared/ShareModal';

const SingleShortsVideo = () => {
    const [searchParams] = useSearchParams();
    const [shortsVideo, setShortsVideo] = useState([]);
    const [openCommentVideoId, setOpenCommentVideoId] = useState(null);
    const [comments, setComments] = useState([]);
    const [commentText, setCommentText] = useState("");
    const commentBoxRef = useRef(null);
    const [isMuted, setIsMuted] = useState(true);
    const videoRef = useRef(null);
    const [shareDialogOpen, setShareDialogOpen] = useState(false);
    const [selectedVideoForShare, setSelectedVideoForShare] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [activeVoteResponse, setActiveVoteResponse] = useState(null);
    const [activeVoteDetails, setActiveVoteDetails] = useState(null);
    const [faceRecognitionDialogOpen, setFaceRecognitionDialogOpen] = useState(false);
    const [pendingVote, setPendingVote] = useState(null);
    const [isSignIn, setIsSignIn] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUserVerified, setIsUserVerified] = useState('');
    const [isSubscribed, setIsSubscribed] = useState(true);
    const [isSubscriptionEnable, setIsSubscriptionEnable] = useState(false);
    const [subscriptionDialogOpen, setSubscriptionDialogOpen] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const [selectedCardId, setSelectedCardId] = useState(null);
    const [selectedCreatorName, setSelectedCreatorName] = useState('');
    const [selectedCreatorUserId, setSelectedCreatorUserId] = useState('');
    const [isReportClicked, setIsReportClicked] = useState(false);
    const isCommentIconClickedRef = useRef(false);
    const [playingVoteVideos, setPlayingVoteVideos] = useState({});
    const [commentLoader, setCommentLoader] = useState(false);
    const govtHook = useGovtIdVerification();
    const [profilePromptOpen, setProfilePromptOpen] = useState(false);
    const [profilePromptMessage, setProfilePromptMessage] = useState('');

    // Helper function to get user initials
    const getUserInitials = (userName) => {
        if (!userName) return '';
        const words = userName.trim().split(' ');
        if (words.length === 1) {
            return words[0].charAt(0).toUpperCase();
        }
        const firstInitial = words[0] ? words[0].charAt(0).toUpperCase() : '';
        const lastInitial = words[words.length - 1] ? words[words.length - 1].charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial;
    };

    // Helper function to generate background color based on initials
    const getBackgroundColor = (initials) => {
        const colors = [
            '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4',
            '#FFEAA7', '#DDA0DD', '#98D8C8', '#F7DC6F',
            '#BB8FCE', '#85C1E9', '#F8C471', '#82E0AA'
        ];

        let hash = 0;
        for (let i = 0; i < initials.length; i++) {
            hash = initials.charCodeAt(i) + ((hash << 5) - hash);
        }
        hash = Math.abs(hash);
        return colors[hash % colors.length];
    };

    useEffect(() => {
        fetchShortsVideo();
        // Add click event listener
        const handleClickOutside = (event) => {
            // Skip if comment icon was just clicked
            if (isCommentIconClickedRef.current) {
                isCommentIconClickedRef.current = false;
                return;
            }

            if (commentBoxRef.current && !commentBoxRef.current.contains(event.target)) {
                setOpenCommentVideoId(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (activeVoteResponse) {
            console.log("activeVoteResponse:", activeVoteResponse);
            try {
                const fetchVoteDetails = async () => {
                    const credentials = {
                        "voteId": activeVoteResponse,
                        "userId": getUserId()
                    }
                    const response = await getVoteDetailsById(credentials);
                    console.log("response from getVoteDetailsById api:", response);
                    if (response.isVoted === false) {
                        setActiveVoteDetails(response);
                    } else {
                        setActiveVoteDetails(null);
                    }
                }
                fetchVoteDetails();
            } catch (error) {
                console.error("error in getVoteDetailsById:", error);
            }
        }
    }, [activeVoteResponse]);

    useEffect(() => {
        const userId = getUserId();
        const getUserDetails = async () => {
            const response = await getUser(userId);
            console.log(" response from getUser api:", response.data);
            if (response.data?.governmentId === null) {
                setIsUserVerified('notUploaded');
            } else if (response.data?.governmentId?.verificationStatus === 'approved') {
                setIsUserVerified('verified');
            } else if (response.data?.governmentId?.verificationStatus === 'rejected') {
                setIsUserVerified('rejected');
            }
            else {
                setIsUserVerified('pending');
            }
            if (typeof response.data?.isSubscribed !== 'undefined') {
                setIsSubscribed(!!response.data.isSubscribed);
            }
            if (typeof response.data?.isSubscriptionEnable !== 'undefined') {
                setIsSubscriptionEnable(!!response.data.isSubscriptionEnable);
            }
        }
        getUserDetails();
    }, []);

    useEffect(() => {
        console.log("isUserVerified", isUserVerified);
    }, [isUserVerified]);

    // Effect to handle body scrolling when popup is open
    useEffect(() => {
        if (showPopup) {
            // Disable scrolling
            document.body.style.overflow = 'hidden';
        } else {
            // Re-enable scrolling
            document.body.style.overflow = 'unset';
        }

        // Cleanup function to ensure scrolling is re-enabled when component unmounts
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [showPopup]);

    const fetchShortsVideo = async () => {
        const videoId = searchParams.get('videoId');
        const userId = getUserId();
        try {
            const response = await getVideoById(userId, videoId);
            console.log("response from getAllShorts api:", response);
            setShortsVideo(response.data);
        } catch (error) {
            console.error('Error fetching shorts video:', error);
        }
    };

    const handleLikeDislike = async (videoId) => {
        // Government ID presence check
        const govCheck = govtHook.check();
        if (!govCheck.allowed) {
            setProfilePromptMessage(govCheck.reason);
            setProfilePromptOpen(true);
            return;
        }
        if (isSubscriptionEnable && !isSubscribed) {
            setSubscriptionDialogOpen(true);
            return;
        }
        const userId = getUserId();
        const credentials = {
            "userId": userId,
            "videoId": videoId
        }
        try {
            const response = await likeDislikeShorts(credentials);
            console.log("response from likeDislike api:", response);

            setShortsVideo(prevVideos =>
                prevVideos.map(video => {
                    if (video.videoId === videoId) {
                        return {
                            ...video,
                            isLiked: !video.isLiked,
                            likeCount: video.isLiked ? video.likeCount - 1 : video.likeCount + 1
                        };
                    }
                    return video;
                })
            );
        } catch (error) {
            console.error("error in likeDislike:", error);
        }
    };

    const handleCommentLikeDislike = async (videoId, commentId, action) => {
        const comment = comments.find(c => c.commentId === commentId);
        if (!comment) return;

        if (action === 'up' && comment.isLiked) return;
        if (action === 'down' && !comment.isLiked) return;

        const govCheck = govtHook.check();
        if (!govCheck.allowed) {
            setProfilePromptMessage(govCheck.reason);
            setProfilePromptOpen(true);
            return;
        }
        if (isSubscriptionEnable && !isSubscribed) {
            setSubscriptionDialogOpen(true);
            return;
        }

        const token = getToken();
        const userId = getUserId();
        
        try {
            const response = await likeDislike({ voteId: videoId, userId, targetId: commentId, targetType: 1 }, token);
            console.log("response from comment likeDislike api:", response);
            setComments(prevComments => {
                let updated = prevComments.map(c => {
                    if (c.commentId === commentId) {
                        return {
                            ...c,
                            isLiked: !c.isLiked,
                            likeCount: c.isLiked ? Math.max(0, c.likeCount - 1) : c.likeCount + 1
                        };
                    }
                    return c;
                });
                return updated.sort((a, b) => b.likeCount - a.likeCount);
            });
        } catch (error) {
            console.error("error in comment likeDislike:", error);
        }
    };

    const handleCommentIconClick = async (e, videoId) => {
        // Prevent event bubbling to avoid interference with click outside handler
        e.stopPropagation();

        // Set flag to prevent click outside handler from interfering
        isCommentIconClickedRef.current = true;

        // Use a simple toggle approach - if it's open for this video, close it, otherwise open it
        if (openCommentVideoId === videoId) {
            // Close the comment box
            setOpenCommentVideoId(null);
            setComments([]);
        } else {
            // Open the comment box (close any other open comment first)
            try {
                const response = await getComments(videoId);
                console.log("response from getComments api:", response);
                const sortedComments = [...(response || [])].sort((a, b) => b.likeCount - a.likeCount);
                setComments(sortedComments);
                setOpenCommentVideoId(videoId);
            } catch (error) {
                console.error("error in getComments:", error);
            }
        }

        // Reset flag after a short delay
        setTimeout(() => {
            isCommentIconClickedRef.current = false;
        }, 100);
    };

    const handleCommentSubmit = async () => {
        if (commentLoader) return;
        // Government ID presence check
        const govCheck = govtHook.check();
        if (!govCheck.allowed) {
            setProfilePromptMessage(govCheck.reason);
            setProfilePromptOpen(true);
            return;
        }
        if (isSubscriptionEnable && !isSubscribed) {
            setSubscriptionDialogOpen(true);
            return;
        }
        setCommentLoader(true);
        if (commentText.trim() === "") {
            return;
        }
        const userId = getUserId();
        const credentials = {
            "userId": userId,
            "videoId": openCommentVideoId,
            "commentText": commentText
        }
        try {
            const response = await addComment(credentials);
            console.log("response from addComment api:", response);
            // Fetch updated comments
            const updatedComments = await getComments(openCommentVideoId);
            const sortedComments = [...(updatedComments || [])].sort((a, b) => b.likeCount - a.likeCount);
            setComments(sortedComments);

            // Update the comment count in shortsVideo state
            setShortsVideo(prevVideos =>
                prevVideos.map(video => {
                    if (video.videoId === openCommentVideoId) {
                        return {
                            ...video,
                            commentCount: video.commentCount + 1
                        };
                    }
                    return video;
                })
            );
        } catch (error) {
            console.error("error in addComment:", error);
        } finally {
            setCommentLoader(false);
            setCommentText("");
        }
    }

    const handleDeleteComment = async (commentId) => {
        const userId = getUserId();
        const credentials = {
            "userId": userId,
            "commentId": commentId
        }
        try {
            await deleteComment(credentials);

            // Fetch updated comments
            const updatedComments = await getComments(openCommentVideoId);
            const sortedComments = [...(updatedComments || [])].sort((a, b) => b.likeCount - a.likeCount);
            setComments(sortedComments);

            // Update the comment count in shortsVideo state
            setShortsVideo(prevVideos =>
                prevVideos.map(video => {
                    if (video.videoId === openCommentVideoId) {
                        return {
                            ...video,
                            commentCount: video.commentCount - 1
                        };
                    }
                    return video;
                })
            );
        } catch (error) {
            console.error("error in deleteComment:", error);
        }
    };

    const handleVolumeToggle = (event) => {
        event.stopPropagation();
        setIsMuted(!isMuted);
        if (videoRef.current) {
            videoRef.current.muted = !isMuted;
        }
    };

    const handleShare = async (video) => {
        setSelectedVideoForShare(video);
        setShareDialogOpen(true);
    };

    const handleSystemShare = async () => {
        const userId = getUserId();
        const shareUrl = `${window.location.origin}/single-shorts-video?videoId=${selectedVideoForShare.videoId}`;
        const shareData = {
            title: 'Share Video',
            text: selectedVideoForShare.description,
            url: shareUrl,
        };

        try {
            if (navigator.share) {
                await navigator.share(shareData);
            }
        } catch (error) {
            console.error('Error sharing:', error);
        }
        setShareDialogOpen(false);
    };

    const handleCopyLink = () => {
        const shareUrl = `${window.location.origin}/single-shorts-video?videoId=${selectedVideoForShare.videoId}`;
        navigator.clipboard.writeText(shareUrl).then(() => {
            setSnackbarMessage('Link copied to clipboard!');
            setSnackbarOpen(true);
            setShareDialogOpen(false);
        });
    };

    // Help popup handler functions
    const handleHelpClick = (e, cardId, creatorName, creatorUserId) => {
        e.preventDefault();
        e.stopPropagation();
        const rect = e.currentTarget.getBoundingClientRect();

        // Get viewport dimensions
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        // Estimate popup dimensions (you can adjust these based on your CSS)
        const popupHeight = 200; // Adjust based on your popup height
        const popupWidth = 250; // Adjust based on your popup width

        // Calculate available space
        const spaceBelow = viewportHeight - rect.bottom;
        const spaceAbove = rect.top;
        const spaceRight = viewportWidth - rect.right;
        const spaceLeft = rect.left;

        // Determine vertical position
        let top;
        if (spaceBelow >= popupHeight) {
            // Position below the button
            top = rect.bottom;
        } else if (spaceAbove >= popupHeight) {
            // Position above the button
            top = rect.top - popupHeight;
        } else {
            // Center vertically if neither space is sufficient
            top = Math.max(0, (viewportHeight - popupHeight) / 2);
        }

        // Determine horizontal position
        let left;
        if (spaceLeft >= popupWidth) {
            // Position to the left of the button (current behavior)
            left = rect.left - popupWidth;
        } else if (spaceRight >= popupWidth) {
            // Position to the right of the button
            left = rect.right;
        } else {
            // Center horizontally if neither space is sufficient
            left = Math.max(0, (viewportWidth - popupWidth) / 2);
        }

        setPopupPosition({
            top: top,
            left: left
        });
        setSelectedCardId(cardId);
        setSelectedCreatorName(creatorName);
        setSelectedCreatorUserId(creatorUserId);
        setShowPopup(true);
        setIsReportClicked(false);
    };

    const handleClickOutsidePopup = (e) => {
        if (e.target.className === 'popupOverlay') {
            setShowPopup(false);
        }
    };

    const handleReport = () => {
        setIsReportClicked(!isReportClicked);
    };

    const handleReportOption = (option) => {
        setShowPopup(false);
    };

    const handleVoteOptionClick = (voteId, optionId) => {
        setPendingVote({ voteId, optionId });
        setFaceRecognitionDialogOpen(true);
    };

    const handleVoteVideoPlayPause = (voteId, event) => {
        event.stopPropagation();
        const videoElement = event.target.closest('.voteMediaContainer').querySelector('video');

        if (videoElement) {
            if (playingVoteVideos[voteId]) {
                videoElement.pause();
                setPlayingVoteVideos(prev => ({ ...prev, [voteId]: false }));
            } else {
                videoElement.play();
                setPlayingVoteVideos(prev => ({ ...prev, [voteId]: true }));
            }
        }
    };

    const handleFaceRecognitionSuccess = () => {
        setIsSignIn(true);
    };

    const handleDeleteShortsVideo = async (videoId) => {
        try {
            const userId = getUserId();
            const credentials = {
                "userId": userId,
                "videoId": videoId
            };

            const response = await deleteShortsVideo(credentials);
            console.log("response from deleteShortsVideo api:", response);

            // Close the popup and redirect or show success message
            setShowPopup(false);

            // You might want to redirect to shorts page or show a success message
            window.history.back(); // Go back to previous page

        } catch (error) {
            console.error("error in deleteShortsVideo:", error);
        }
    };

    useEffect(() => {
        if (isSignIn && pendingVote) {
            const submit = async () => {
                const userId = getUserId();
                try {
                    const response = await submitVote({ voteId: pendingVote.voteId, userId, optionId: pendingVote.optionId });
                    console.log(" response from submitVote api:", response);
                    // Refetch the vote details to update percentages and isVoted
                    const updatedDetails = await getVoteDetailsById({ voteId: pendingVote.voteId, userId });
                    setActiveVoteDetails(updatedDetails);
                    setActiveVoteResponse(null); // Optionally close the popup after voting
                    setTimeout(() => {
                        setActiveVoteDetails(null);
                        // Restart the video
                        if (videoRef.current) {
                            videoRef.current.currentTime = 0;
                            videoRef.current.play().catch(error => console.log("Playback failed:", error));
                        }
                    }, 1500); // Show result for 1.5s, then close
                } catch (error) {
                    console.log("error", error);
                }
                setIsSignIn(false);
                setFaceRecognitionDialogOpen(false);
                setPendingVote(null);
            };
            submit();
        }
    }, [isSignIn, pendingVote]);

    return (
        <div className="BallotsPage">
            <div className='ballotsPageContainer'>
                <div className='headerContain'>
                    <Header />
                </div>
                <div className='ballotsPageContainer2'>
                    <div className='sidebarContain'>
                        <Sidebar />
                    </div>
                    <div className='middleContainer'>
                        {activeVoteDetails && (
                            <div className='votePopupContainer'>
                                <div className="shorts-blur"></div>
                                <div
                                    className="voteResponsePopup"
                                    style={{
                                        position: 'fixed',
                                        top: '54%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        background: '#222',
                                        color: '#fff',
                                        padding: '24px 32px',
                                        borderRadius: '12px',
                                        zIndex: 10000,
                                        boxShadow: '0 4px 24px rgba(0,0,0,0.3)',
                                        minWidth: '250px',
                                        textAlign: 'center',
                                        maxHeight: '70vh',
                                        height: 'auto',
                                        width: '30vw',
                                        overflow: 'auto',
                                        scrollbarWidth: 'thin',
                                        scrollbarColor: '#888 #222'
                                    }}
                                >
                                    <button
                                        onClick={() => {
                                            setActiveVoteResponse(null);
                                            setActiveVoteDetails(null);
                                            // Restart the video
                                            if (videoRef.current) {
                                                videoRef.current.currentTime = 0;
                                                videoRef.current.play().catch(error => console.log("Playback failed:", error));
                                            }
                                        }}
                                        style={{
                                            position: 'absolute',
                                            top: 8,
                                            right: 12,
                                            background: 'transparent',
                                            border: 'none',
                                            color: '#fff',
                                            fontSize: 30,
                                            cursor: 'pointer',
                                            zIndex: 10001,
                                        }}
                                    >
                                        ×
                                    </button>

                                    {/* Profile Section */}
                                    <div className="feedCardHeader" style={{ marginBottom: '20px' }}>
                                        <div className="profileDetailsContainer">
                                            {activeVoteDetails.createdByUserPhoto ? (
                                                <img
                                                    src={activeVoteDetails.createdByUserPhoto}
                                                    alt="no-img-found"
                                                    className="profilePic"
                                                />
                                            ) : (
                                                <div
                                                    className="profilePic"
                                                    style={{
                                                        backgroundColor: getBackgroundColor(getUserInitials(activeVoteDetails.displayName)),
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        color: 'white',
                                                        fontWeight: 'bold',
                                                        fontSize: '16px',
                                                        fontFamily: 'Arial, sans-serif'
                                                    }}
                                                >
                                                    {getUserInitials(activeVoteDetails.displayName)}
                                                </div>
                                            )}
                                            <div className="profileDetails">
                                                <span className="profileNameText">{activeVoteDetails.displayName ? activeVoteDetails.displayName : activeVoteDetails.createdByUserName}</span>
                                            </div>
                                        </div>
                                        <div className="timeContainer">
                                            {activeVoteDetails.isPaused ? <div className="pausedContainer"><span className="pausedtext">Paused</span></div> : <div className="timeContainer"><span className="timeText">{getHumanizedTime(activeVoteDetails.createdOn)}</span></div>}
                                        </div>
                                    </div>

                                    <div className="voteTitleContainer">
                                        <span className="voteTitleText">
                                            {activeVoteDetails.title}
                                        </span>
                                    </div>
                                    {activeVoteDetails.imageUrls?.[0] && <div className="voteMediaContainer" style={{ height: '60%' }}>
                                        <img
                                            src={activeVoteDetails.imageUrls[0] || "/Sidebar/voteImage.svg"}
                                            alt="no-img-found"
                                            style={{ width: '80%', height: '100%' }}
                                        />
                                    </div>}
                                    {activeVoteDetails.videoUrl && <div className="voteMediaContainer" style={{ position: 'relative' }}>
                                        <video
                                            src={activeVoteDetails.videoUrl}
                                            alt="no-video-found"
                                            muted
                                            loop
                                            onPlay={() => setPlayingVoteVideos(prev => ({ ...prev, [activeVoteDetails.voteId]: true }))}
                                            onPause={() => setPlayingVoteVideos(prev => ({ ...prev, [activeVoteDetails.voteId]: false }))}
                                            onClick={(e) => handleVoteVideoPlayPause(activeVoteDetails.voteId, e)}
                                            style={{
                                                width: '80%',
                                                height: '100%',
                                                cursor: "pointer"
                                            }}
                                        />

                                        {/* Play/Pause Button Overlay */}
                                        {!playingVoteVideos[activeVoteDetails.voteId] && (
                                            <div
                                                className="playPauseOverlay"
                                                style={{
                                                    position: 'absolute',
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    cursor: 'pointer',
                                                    zIndex: 10
                                                }}
                                                onClick={(e) => handleVoteVideoPlayPause(activeVoteDetails.voteId, e)}
                                            >
                                                <PlayArrowRoundedIcon
                                                    sx={{
                                                        color: "#5AAF9A",
                                                        fontSize: "70px",
                                                        cursor: "pointer",
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>}
                                    {activeVoteDetails.fileUrl && activeVoteDetails.fileUrl.endsWith('.pdf') && (
                                        <div className="pdfLinkContainer">
                                            <a
                                                href={`https://drive.google.com/viewerng/viewer?url=${encodeURIComponent(activeVoteDetails.fileUrl)}&embedded=true`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pdfLink"
                                            >
                                                <PictureAsPdfRoundedIcon sx={{ color: "black", fontSize: { xs: "15px", sm: "20px", md: "20px", lg: "25px" } }} />
                                                View PDF
                                            </a>
                                        </div>
                                    )}

                                    {/* Description Section */}
                                    <div className="shortsVoteDescriptionContainer" style={{ marginBottom: '20px' }}>
                                        <span className="voteDescriptionText">{activeVoteDetails.description}</span>
                                    </div>

                                    <div className="voteBtnsContainer">
                                        {activeVoteDetails.options.map((option) => (
                                            <button
                                                key={option.id}
                                                className={`vote-button-wrapper ${activeVoteDetails.isVoted ? 'voted' : ''} ${option.isSelected ? 'selected' : ''}`}
                                                onClick={() => !activeVoteDetails.isVoted && handleVoteOptionClick(activeVoteDetails.voteId, option.id)}
                                                disabled={activeVoteDetails.isVoted || activeVoteDetails.isPaused}
                                            >
                                                {activeVoteDetails.isVoted && (
                                                    <div
                                                        className="vote-progress-bar"
                                                        style={{ width: `${option.percentage}%` }}
                                                    />
                                                )}
                                                <span className="vote-text">{option.value}</span>
                                                {activeVoteDetails.isVoted && (
                                                    <span className="vote-percentage">{option.percentage}%</span>
                                                )}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        {isLoading ? (
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh', width: '100%', gap: '20px' }}>
                                <Loader containerSize="3rem" />
                                <p style={{
                                    color: '#ffffff',
                                    fontWeight: '600',
                                    fontSize: '1rem',
                                    textTransform: 'uppercase',
                                    letterSpacing: '1.5px',
                                    textAlign: 'center',
                                    maxWidth: '90%',
                                    lineHeight: '1.4',
                                    fontFamily: '"Inter", sans-serif',
                                    opacity: 0.8
                                }}>
                                    Hang tight, we’re getting things ready for you...
                                </p>
                            </div>
                        ) : (
                            <div className="ShortsVideo">
                                <div className="shortsVideoContainer">
                                    <div className="shortsVideoContainer2" >
                                        <div className="videoContainer">
                                            <video
                                                ref={videoRef}
                                                src={shortsVideo.videoUrl}
                                                autoPlay
                                                loop
                                                muted={isMuted}
                                                playsInline
                                                className='videoElement'
                                                onEnded={() => {
                                                    // If this video should open a vote dialog
                                                    if (!shortsVideo.voteResponse?.isVoted && shortsVideo?.voteId) {
                                                        setActiveVoteResponse(shortsVideo.voteId);
                                                        console.log("shortsVideo.voteResponse:", shortsVideo);
                                                    } else {
                                                        console.log("shortsVideo.voteResponse:", shortsVideo);
                                                        // Otherwise, loop the video manually
                                                        if (videoRef.current) {
                                                            videoRef.current.currentTime = 0;
                                                            videoRef.current.play();
                                                        }
                                                    }
                                                }}
                                            />
                                            {/* <div className="timeContainer" style={{
                                                position: 'absolute',
                                                top: '10px',
                                                right: '20px',
                                                background: 'rgba(0, 0, 0, 0.5)',
                                                borderRadius: '50%',
                                                padding: '8px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginBottom: '10px'
                                            }}>
                                                <img
                                                    src="/Sidebar/helpCenterIcon.svg"
                                                    alt="no img found"
                                                    className="sidebarHeadingIcon"
                                                    onClick={(e) => handleHelpClick(e, shortsVideo.videoId, shortsVideo.createdByUserName)}
                                                    style={{
                                                        width: '25px',
                                                        height: '25px',
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </div>
                                            <div className="volumeControlContainer">
                                                {isMuted ? (
                                                    <VolumeOffIcon
                                                        onClick={handleVolumeToggle}
                                                        sx={{
                                                            color: "#fff",
                                                            fontSize: "24px",
                                                            cursor: "pointer",
                                                            "&:hover": { opacity: 0.8 }
                                                        }}
                                                    />
                                                ) : (
                                                    <VolumeUpIcon
                                                        onClick={handleVolumeToggle}
                                                        sx={{
                                                            color: "#fff",
                                                            fontSize: "24px",
                                                            cursor: "pointer",
                                                            "&:hover": { opacity: 0.8 }
                                                        }}
                                                    />
                                                )}
                                            </div> */}
                                            <div className="infoContainer">
                                                <div className="volumeControlContainer">
                                                    <InfoOutlineRoundedIcon
                                                        onClick={(e) => handleHelpClick(e, shortsVideo.videoId, shortsVideo.createdByUserName, shortsVideo.createdByUser)}
                                                        sx={{
                                                            color: "#fff",
                                                            fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                                                            cursor: "pointer",
                                                        }}
                                                    />
                                                </div>
                                                <div className="volumeControlContainer">
                                                    {!isMuted ? (
                                                        <VolumeUpIcon
                                                            onClick={handleVolumeToggle}
                                                            sx={{
                                                                color: "#fff",
                                                                fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                                                                cursor: "pointer",
                                                                "&:hover": { opacity: 0.8 }
                                                            }}
                                                        />
                                                    ) : (
                                                        <VolumeOffIcon
                                                            onClick={handleVolumeToggle}
                                                            sx={{
                                                                color: "#fff",
                                                                fontSize: { xs: "10px", sm: "13px", md: "15px", lg: "20px" },
                                                                cursor: "pointer",
                                                                "&:hover": { opacity: 0.8 }
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            <div className='shortsVideoDetailsContainer'>
                                                <div className='shortsVideoProfileDetails'>
                                                    {shortsVideo.createdByUserPhoto !== null ? (
                                                        <div className='shortsVideoProfilePicContainer'>
                                                            <img src={shortsVideo.createdByUserPhoto} alt="no-img-found" className='shortsVideoProfilePic' />
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="shortsVideoProfilePic"
                                                            style={{
                                                                backgroundColor: getBackgroundColor(getUserInitials(shortsVideo.createdByUserName)),
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                color: 'white',
                                                                fontWeight: 'bold',
                                                                fontSize: '14px',
                                                                fontFamily: 'Arial, sans-serif'
                                                            }}
                                                        >
                                                            {getUserInitials(shortsVideo.createdByUserName)}
                                                        </div>
                                                    )}
                                                    <div className='shortsVideoProfileNameContainer'>
                                                        <span className='shortsVideoProfileName'>{shortsVideo.createdByUserName}</span>
                                                        <span className="videoCommentItemTime">{getHumanizedTime(shortsVideo.createdAt)}</span>
                                                    </div>
                                                </div>
                                                <div className='shortsVideoDescriptionContainer'>
                                                    <span className='shortsVideoDescriptionText'>{shortsVideo.description}</span>
                                                </div>
                                            </div>
                                            <div className='actionContainer'>
                                                <div className={`actionItem ${shortsVideo.isLiked ? 'liked' : ''}`} onClick={() => handleLikeDislike(shortsVideo.videoId)}>
                                                    {shortsVideo.isLiked ? (
                                                        <FavoriteRoundedIcon sx={{ color: "#FF0000", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                                                    ) : (
                                                        <FavoriteBorderRoundedIcon sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                                                    )}
                                                    <span className={`countText ${shortsVideo.isLiked ? 'liked-text' : ''}`}>{shortsVideo.likeCount}</span>
                                                </div>
                                                <div className='actionItem'>
                                                    <ChatBubbleOutlineRoundedIcon
                                                        sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }}
                                                        onClick={(e) => {
                                                            handleCommentIconClick(e, shortsVideo.videoId);
                                                        }}
                                                    />
                                                    <span className='countText'>{shortsVideo.commentCount}</span>
                                                </div>
                                                <div className='actionItem'>
                                                    <div className="voteShareContainer">
                                                        <NearMeOutlinedIcon
                                                            sx={{ color: "#fff", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }}
                                                            onClick={() => handleShare(shortsVideo)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {openCommentVideoId === shortsVideo.videoId && (
                                                <div
                                                    className='commentDialogContainer'
                                                    ref={commentBoxRef}
                                                    onClick={(e) => e.stopPropagation()} // Prevent clicks inside from closing
                                                >
                                                    <div className='commentHeaderContainer'>
                                                        <div className='commentHeaderLeft'>
                                                            <span className='commentHeaderText'>Comments</span>
                                                            <span className='commentHeaderBadge'>{comments.length}</span>
                                                        </div>
                                                        <button
                                                            type='button'
                                                            className='commentCloseBtn'
                                                            onClick={() => {
                                                                setOpenCommentVideoId(null);
                                                                setComments([]);
                                                            }}
                                                            aria-label='Close comments'
                                                        >
                                                            <CloseIcon sx={{ fontSize: '18px' }} />
                                                        </button>
                                                    </div>

                                                    <div className='commentContentContainer'>
                                                        {comments.length === 0 && (
                                                            <div className='noCommentContainer'>
                                                                <div className='noCommentIconWrapper'>
                                                                    <ChatBubbleOutlineRoundedIcon sx={{ fontSize: '26px', color: '#5AAF9A' }} />
                                                                </div>
                                                                <span className='noCommentsTitle'>No comments yet</span>
                                                                <span className='noCommentsSubtitle'>Be the first to share your thoughts!</span>
                                                            </div>
                                                        )}
                                                        {comments.length > 0 && comments.map((comment) => (
                                                            <div key={comment.commentId} className='videoCommentItem'>
                                                                {comment.userPhoto ? (
                                                                    <img src={comment.userPhoto} alt={comment.userName} className='videoCommentItemProfilePic' />
                                                                ) : (
                                                                    <div
                                                                        className="videoCommentItemProfilePic"
                                                                        style={{
                                                                            backgroundColor: getBackgroundColor(getUserInitials(comment.userName)),
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            color: 'white',
                                                                            fontWeight: 'bold',
                                                                            fontSize: '13px',
                                                                            fontFamily: 'Satoshi, sans-serif'
                                                                        }}
                                                                    >
                                                                        {getUserInitials(comment?.userName)}
                                                                    </div>
                                                                )}
                                                                <div className='videoCommentItemTextContainer'>
                                                                    <div className='videoCommentItemHeader'>
                                                                        <span className='videoCommentItemUserName'>{comment.userName}</span>
                                                                        <span className='videoCommentItemTime'>{getHumanizedTime(comment?.createdAt)}</span>
                                                                    </div>
                                                                    <span className='videoCommentItemCommentText'>{comment.commentText}</span>
                                                                    <div className="commentActionsRow" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                                                                        <div className='commentVotePill'>
                                                                            <KeyboardArrowUpRoundedIcon 
                                                                                sx={{ 
                                                                                    color: comment.isLiked ? "#5AAF9A" : "#808080", 
                                                                                    fontSize: "18px", 
                                                                                    cursor: comment.isLiked ? "default" : "pointer",
                                                                                    "&:hover": { color: "#5AAF9A" }
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleCommentLikeDislike(openCommentVideoId, comment.commentId, 'up');
                                                                                }}
                                                                            />
                                                                            <span className='commentVoteCount'>
                                                                                {comment.likeCount || 0}
                                                                            </span>
                                                                            <KeyboardArrowDownRoundedIcon 
                                                                                sx={{ 
                                                                                    color: !comment.isLiked ? "#808080" : "#808080",
                                                                                    fontSize: "18px", 
                                                                                    cursor: !comment.isLiked ? "default" : "pointer",
                                                                                    "&:hover": { color: "#ffffff" }
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleCommentLikeDislike(openCommentVideoId, comment.commentId, 'down');
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {comment?.userId === getUserId() && (
                                                                    <DeleteOutlineRoundedIcon
                                                                        className='deleteCommentIcon'
                                                                        sx={{
                                                                            color: "rgba(255, 255, 255, 0.4)",
                                                                            fontSize: { xs: "15px", md: "18px" },
                                                                            cursor: "pointer",
                                                                            "&:hover": { color: "#E57373" }
                                                                        }}
                                                                        onClick={() => handleDeleteComment(comment.commentId)}
                                                                    />
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className='commentShortsInputContainer'>
                                                        <div className='commentInputWrapper'>
                                                            <input
                                                                type='text'
                                                                className='commentInput'
                                                                placeholder='Add a comment...'
                                                                onChange={(e) => setCommentText(e.target.value)}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        handleCommentSubmit();
                                                                    }
                                                                }}
                                                                value={commentText}
                                                            />
                                                            <button
                                                                type='button'
                                                                className={`shortsCommentSendBtn ${commentText.trim() ? 'active' : ''}`}
                                                                onClick={handleCommentSubmit}
                                                                disabled={!commentText.trim() || commentLoader}
                                                                aria-label='Send comment'
                                                            >
                                                                <SendRoundedIcon sx={{ fontSize: '16px' }} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <ShareModal
                                    open={shareDialogOpen}
                                    onClose={() => setShareDialogOpen(false)}
                                    item={selectedVideoForShare || (shortsVideo && shortsVideo[0])}
                                    shareType="short"
                                    onToast={(msg) => {
                                        setSnackbarMessage(msg);
                                        setSnackbarOpen(true);
                                    }}
                                />

                                {/* Snackbar for copy confirmation */}
                                <Snackbar
                                    open={snackbarOpen}
                                    autoHideDuration={3000}
                                    onClose={() => setSnackbarOpen(false)}
                                    message={snackbarMessage}
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                />

                                <SubscriptionPrompt
                                    open={subscriptionDialogOpen}
                                    onClose={() => setSubscriptionDialogOpen(false)}
                                    message={"Please purchase a subscription from the Android or iOS app to like or comment on shorts."}
                                />

                                {/* Face Recognition Dialog */}
                                <Dialog
                                    open={faceRecognitionDialogOpen}
                                    onClose={() => setFaceRecognitionDialogOpen(false)}
                                    maxWidth="md"
                                    fullWidth
                                    PaperProps={{
                                        sx: {
                                            width: '50vw',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: 3,
                                            overflow: 'hidden',
                                            marginTop: '150px',
                                            backgroundColor: '#0e1b1b',
                                            position: 'relative',
                                        }
                                    }}
                                >
                                    <DialogTitle sx={{ color: 'white', width: '100%', pr: 5, pl: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        Verify your identity
                                        <CloseIcon
                                            onClick={() => setFaceRecognitionDialogOpen(false)}
                                            sx={{
                                                position: 'absolute',
                                                right: 16,
                                                top: 16,
                                                color: 'white',
                                                cursor: 'pointer',
                                                fontSize: 28,
                                                zIndex: 10,
                                            }}
                                            aria-label="close"
                                        />
                                    </DialogTitle>
                                    <FaceRecognition
                                        isUserVerified={isUserVerified}
                                        onSuccess={handleFaceRecognitionSuccess}
                                        onCancel={() => setFaceRecognitionDialogOpen(false)}
                                    />
                                </Dialog>
                                <ProfileCompletionPrompt
                                    open={profilePromptOpen}
                                    onClose={() => setProfilePromptOpen(false)}
                                    message={profilePromptMessage || 'Please verify your Government ID using the Amalgamate mobile app on iOS or Android.'}
                                    actionLabel="GOT IT"
                                    secondaryAction={null}
                                    onPrimaryAction={() => setProfilePromptOpen(false)}
                                />

                                {/* Help Popup */}
                                {showPopup && (
                                    <div className="popupOverlay" onClick={handleClickOutsidePopup}>
                                        <div
                                            className="popupContent"
                                            style={{
                                                top: `${popupPosition.top}px`,
                                                left: `${popupPosition.left}px`
                                            }}
                                        >
                                            <span className="popupTitle">Information</span>
                                            {selectedCreatorUserId !== getUserId() && (
                                                <button className="popupBtn saveBtn">
                                                    <PermIdentityRoundedIcon sx={{ color: "#BD564E", fontSize: "24px" }} />
                                                    <span className="reportBtnText">Request Block {selectedCreatorName}</span>
                                                </button>
                                            )}
                                            <button className="popupBtn reportBtn" onClick={handleReport}>
                                                <img src="/Assets/Sidebar/reportIcon.svg" alt="no-img-found" className="informationBtnIcon" />
                                                <span className="reportBtnText">Report this content</span>
                                            </button>
                                            {selectedCreatorUserId === getUserId() && (
                                                <button className="popupBtn saveBtn" onClick={(e) => handleDeleteShortsVideo(selectedCardId)}>
                                                    <DeleteRoundedIcon sx={{ color: "#BD564E", fontSize: { xs: "15px", md: "20px", sm: "15px", lg: "25px" } }} />
                                                    <span className="reportBtnText">Delete</span>
                                                </button>
                                            )}
                                            {isReportClicked && <div className="reportReasonContainer">
                                                <span className="informationBtnText">Select a reason</span>
                                                <div className="reportReasonOptions">
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Harmful or Dangerous Content</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Harrasment or Hate Speech</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Sexual or Inappropriate Content</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Spam or misleading</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Violent or Graphic Content</span>
                                                    <span className="reportReasonOption" onClick={handleReportOption}>Other</span>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                    </div>
                    <div className='dashboardRightSectionContain'>
                        <DashboardRightSection />
                    </div>
                </div>


            </div>
        </div>

    )
}

export default SingleShortsVideo;